import {
  ultimaSettimana,
  ultimoMese,
  meseCorrente,
} from "../const/RadioButtonValue";

const ShortCutDate = (RadioButtonValue) => {
  var today = new Date();
  let begin;
  let end;

  if (RadioButtonValue == ultimoMese) {
    const { beginDate, endDate } = calcPrevMonthDate( today);
    begin = beginDate;
    end = endDate;
  }
  if (RadioButtonValue == ultimaSettimana) {
    const { beginDate, endDate } = calcLastWeek( today);
    begin = beginDate;
    end = endDate;
  }
  if (RadioButtonValue == meseCorrente) {
    const { beginDate, endDate } = calcLastMonth( today);
    begin = beginDate;
    end = endDate;
  }

  return { begin, end };
};


const calcPrevMonthDate = ( today) => {
  const year = today.getFullYear();
  const month = today.getMonth();

  let beginDate = new Date();

  //getMonth() restituisce da 0 a 11. qui dobbiamo passare da 1 a 12 per recuperare il numero massimo di giorni del mese
  const maxDayOfMonth = new Date(year, month + 1, 0).getDate();

  //se il numero di giorni recuperato dal mese corrente è maggiore del numero di giorni del mese passato, lo setta a 1 e non modifico il mese
  beginDate =
    today.getDate() + 1 > maxDayOfMonth
      ? new Date(new Date(beginDate.setDate(1)))
      : new Date(
          new Date(beginDate.setDate(today.getDate() + 1)).setMonth(month - 1)
        );
  beginDate.setHours(0,0,0);

  let endDate = new Date();
  endDate.setHours(23,59,59);
  
  return { beginDate, endDate };
};




const calcLastWeek = ( today) => {
  let beginDate;
  let endDate;

  beginDate = new Date(new Date().setDate(today.getDate() - 6));
  endDate = new Date(new Date().setDate(today.getDate()));

  return { beginDate, endDate };
};

const calcLastMonth = ( today) => {
  let beginDate = new Date(new Date().setDate(1));
  let endDate = new Date(new Date(new Date().setDate(today.getDate())));

  return { beginDate, endDate };
};


export {ShortCutDate,calcPrevMonthDate,calcLastWeek,calcLastMonth};
